import React from 'react';

const Training = () => (
  <div>
    <div className="subheader">
      <h1 className="subheader-title">
        <i className="subheader-icon fal fa-graduation-cap mr-2" />
        Training
      </h1>
    </div>
  </div>
);

export default Training;
